"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    CM1006: 'CM1006',
    TF3000: 'TF3000',
    TF3006: 'TF3006',
    TF3005: 'TF3005',
    TF3008: 'TF3008', // Invalid PromoCode - thrown by Fleet Quote API
};
